import React, { Component } from "react";
import {
  BrowserRouter,
  MemoryRouter,
  Route,
  Switch,
  withRouter
} from "react-router-dom";
import UAParser from "ua-parser-js";
import classSet from "react-classset";
//adding this for documentSize plugin to attach to
import $ from "jquery";
import "jquery.documentsize";
import { Howl } from "howler";
import { loadImage, getParameterByName } from "../../helpers";
import Loading from "../Loading/Loading";
import Header from "../Header/Header";
import LandingPage from "../LandingPage/LandingPage";
import PlayerPage from "../PlayerPage/PlayerPage";
import NotFoundPage from "../NotFoundPage/NotFoundPage";
const bgImage = process.env.REACT_APP_IMAGES_ROOT + "fpo-bg-image2.jpg";
const poster = process.env.REACT_APP_IMAGES_ROOT + "test-bg-video-poster.jpg";
const audioTrack = process.env.REACT_APP_AUDIO_ROOT + "nucalm-compressed.mp3";
const audioTrack2 = process.env.REACT_APP_AUDIO_ROOT + "nucalm.mp3";

class App extends Component {
  constructor() {
    super();
    this.state = {
      appHeight: 0,
      touch: false,
      playsInline: false,
      orientation: null,
      browser: null,
      memoryRouter: false,
      showingLoading: true,
      showingModal: false,
      showBgVideo: true,
      audioLoaded: false,
      audioDuration: 0,
      hideHeader: false,
      dataLoaded: false
    };
    this.imageAssets = [bgImage, poster];
    this.updateDimensions = this.updateDimensions.bind(this);
  }

  componentWillMount() {
    const appEl = document.getElementsByClassName(
      "dermalogica-sound-sleep-cocoon"
    )[0];
    const uaParser = new UAParser().getResult();
    this.setState({
      hideHeader: appEl.dataset.hideHeader === "1",
      memoryRouter: appEl.dataset.memoryRouter === "1",
      shopUrl: getParameterByName("shop_url")
        ? getParameterByName("shop_url")
        : false,
      browser: uaParser.browser.name,
      touch: uaParser.device.model ? true : false,
      playsInline:
        !uaParser.device.model ||
        (uaParser.os.name === "iOS" &&
          Number(uaParser.os.version.substring(0, 2)) >= 10) ||
        "playsInline" in document.createElement("video")
    });
    this.setupHowl();
    this.getAppData();
  }

  componentDidMount() {
    this.updateDimensions();
    window.addEventListener("resize", this.updateDimensions);
  }

  getAppData() {
    const self = this;
    let request = new XMLHttpRequest();
    request.open("GET", process.env.REACT_APP_TRANSLATION_URL, true);
    request.onload = () => {
      if (request.status >= 200 && request.status < 400) {
        window.appData = JSON.parse(request.responseText).json;
      } else {
        console.log("unable to get app data");
      }
      self.preLoadImages(0);
      self.setState({ dataLoaded: true });
    };
    request.onerror = () => {
      console.log("unable to connect to endpoint");
      console.log(request);
    };
    request.send();
  }

  setupHowl() {
    const useUncompressed = window.location.href.indexOf("uncompressed") > -1;
    const self = this;
    this.audio = new Howl({
      html5: true,
      src: [useUncompressed ? audioTrack2 : audioTrack],
      preload: false
    });
    this.audio.once("load", function() {
      self.setState({ audioLoaded: true });
      self.setState({ audioDuration: Math.ceil(self.audio.duration()) });
    });
    console.log("test");
    if (!this.state.audioRefusedToLoad) {
      window.setTimeout(() => {
        console.log(this.audio);
        if (
          this.audio._state === "unloaded" ||
          this.audio._state === "loading"
        ) {
          console.log("settingState");
          this.setState({ audioRefusedToLoad: true, audioLoaded: true });
        }
      }, 3000);
    }
  }

  checkAudioRefusedToPlay() {
    // if (this.state.audioRefusedToLoad) {
    //   console.log("checkAudio");
    //   if (!this.state.audioLoaded) {
    //     console.log("audioNotLoaded");
    //     this.setState(
    //       {
    //         audioLoaded: true,
    //         audioRefusedToLoad: false
    //       },
    //       () => {
    //         this.audio.unload();
    //         this.setupHowl();
    //       }
    //     );
    //   }
    // }
  }

  preLoadImages(n) {
    loadImage(this.imageAssets[n], () => {
      if (n + 1 === this.imageAssets.length) {
        this.setState({ showingLoading: false });
      } else {
        this.preLoadImages(n + 1);
      }
    });
  }

  updateDimensions() {
    const appEl = document.getElementsByClassName(
      "dermalogica-sound-sleep-cocoon"
    )[0];
    const width = appEl.style.width
      ? Number(appEl.style.width.replace("px", ""))
      : appEl.clientWidth;
    const height = appEl.style.height
      ? Number(appEl.style.height.replace("px", ""))
      : $.windowHeight();
    const orientation = width > height ? "landscape" : "portrait";
    this.setState({
      appHeight: height,
      orientation: orientation,
      mqSm: width >= 414,
      mqMd: width >= 667,
      mqLg: width > 900
    });
  }

  render() {
    console.log(this.state.audioLoaded);
    const commonProps = {
      appHeight: this.state.appHeight,
      orientation: this.state.orientation,
      mqSm: this.state.mqSm,
      mqMd: this.state.mqMd,
      mqLg: this.state.mqLg,
      touch: this.state.touch,
      browser: this.state.browser,
      showingModal: this.state.showingModal,
      shopUrl: this.state.shopUrl
    };

    const appClasses = classSet({
      ssc__app: true,
      "ssc__hide-header": this.state.hideHeader,
      ssc__mqSm: this.state.mqSm,
      ssc__mqMd: this.state.mqMd,
      ssc__mqLg: this.state.mqLg
    });

    const HeaderWithRouter = withRouter(Header);

    const Router = this.state.memoryRouter ? MemoryRouter : BrowserRouter;

    return (
      <Router>
        {this.state.dataLoaded && (
          <div className={appClasses} style={{ height: this.state.appHeight }}>
            <style>{fontFace}</style>

            {this.state.showingLoading && <Loading />}

            {!this.state.hideHeader && <HeaderWithRouter {...commonProps} />}

            <Switch>
              <Route
                exact
                path="/"
                render={routeProps => (
                  <LandingPage
                    {...routeProps}
                    {...commonProps}
                    playsInline={this.state.playsInline}
                  />
                )}
              />
              <Route
                exact
                path="/player"
                render={routeProps => (
                  <PlayerPage
                    {...routeProps}
                    {...commonProps}
                    audio={this.audio}
                    audioLoaded={this.state.audioLoaded}
                    audioDuration={this.state.audioDuration}
                    playsInline={this.state.playsInline}
                    checkAudioRefusedToPlay={this.checkAudioRefusedToPlay.bind(
                      this
                    )}
                  />
                )}
              />
              <Route
                exact
                path="/player/uncompressed"
                render={routeProps => (
                  <PlayerPage
                    {...routeProps}
                    {...commonProps}
                    audio={this.audio}
                    audioLoaded={this.state.audioLoaded}
                    audioDuration={this.state.audioDuration}
                    playsInline={this.state.playsInline}
                    useUncompressed={true}
                    checkAudioRefusedToPlay={this.checkAudioRefusedToPlay.bind(
                      this
                    )}
                  />
                )}
              />
              <Route path="/page-not-found" component={NotFoundPage} />
              <Route component={NotFoundPage} />
            </Switch>
          </div>
        )}
      </Router>
    );
  }
}

const fontFace = `
  @font-face {
    font-family: 'HelveticaNeueLTStd-Lt';
    src:  url('${process.env.REACT_APP_FONTS_ROOT}HelveticaNeueLTStd-Lt.eot');
    src:  url('${
      process.env.REACT_APP_FONTS_ROOT
    }HelveticaNeueLTStd-Lt.eot?#iefix') format('embedded-opentype'),
          url('${process.env.REACT_APP_FONTS_ROOT}HelveticaNeueLTStd-Lt.otf');
    font-weight: normal;
    font-style: normal;
  }
  @font-face {
    font-family: 'HelveticaNeueLTStd-Md';
    src:  url('${process.env.REACT_APP_FONTS_ROOT}HelveticaNeueLTStd-Md.eot');
    src:  url('${
      process.env.REACT_APP_FONTS_ROOT
    }HelveticaNeueLTStd-Md.eot?#iefix') format('embedded-opentype'),
          url('${process.env.REACT_APP_FONTS_ROOT}HelveticaNeueLTStd-Md.otf');
    font-weight: normal;
    font-style: normal;
  }
  @font-face {
    font-family: 'HelveticaNeueLTStd-Roman';
    src:  url('${
      process.env.REACT_APP_FONTS_ROOT
    }HelveticaNeueLTStd-Roman.eot');
    src:  url('${
      process.env.REACT_APP_FONTS_ROOT
    }HelveticaNeueLTStd-Roman.eot?#iefix') format('embedded-opentype'),
          url('${
            process.env.REACT_APP_FONTS_ROOT
          }HelveticaNeueLTStd-Roman.otf');
    font-weight: normal;
    font-style: normal;
  }
  @font-face {
    font-family: 'HelveticaNeueLTStd-Th';
    src:  url('${process.env.REACT_APP_FONTS_ROOT}HelveticaNeueLTStd-Th.eot');
    src:  url('${
      process.env.REACT_APP_FONTS_ROOT
    }HelveticaNeueLTStd-Th.eot?#iefix') format('embedded-opentype'),
          url('${process.env.REACT_APP_FONTS_ROOT}HelveticaNeueLTStd-Th.otf');
    font-weight: normal;
    font-style: normal;
  }
`;

export default App;



// WEBPACK FOOTER //
// ./src/components/App/App.js